import { sorting } from './navigation-sorting';
import { default as FEATURES } from './feature-enum';

export const NAVIGATION = Object.freeze({
  MyProfile: 'My Details',
  Compliance: 'Compliance',
  ManageTents: 'Manage Tenants',
  PropertyList: 'Property List',
  FinancialPack: 'Financial Pack',
  AccountHistory: 'Account History',
  PaymentApprovals: 'Payment Approvals',
  PersonalDocuments: 'Personal Documents',
  BuildingDocuments: 'Building Documents',
  PaymentAuthorisation: 'Payment Authorisation',
  Utility: 'Building Information',
  DocumentsApproval: 'Documents Approval',
  ShowFindAContractor: 'Find A Contractor',
 /* TrusteeDashboard: 'Trustee Dashboard'*/
});

export const navigationToClaim = description => {
  let claimLink;

  switch (description) {
    case NAVIGATION.ManageTenants:
      claimLink = FEATURES.TENANT;
      break;
    case NAVIGATION.PaymentApprovals:
      claimLink = FEATURES.PAYMENTS;
      break;
    case NAVIGATION.BuildingDocuments:
      claimLink = FEATURES.DOCUMENTS;
      break;
    case NAVIGATION.PropertyList:
      claimLink = FEATURES.DASHBOARD;
      break;
    case NAVIGATION.MyProfile:
      claimLink = FEATURES.MY_PROFILE;
      break;
    case NAVIGATION.Compliance:
      claimLink = FEATURES.COMPLIANCE;
      break;
    case NAVIGATION.FinancialPack:
      claimLink = FEATURES.FINANCIAL_SUMMARY;
      break;
    case NAVIGATION.AccountHistory:
      claimLink = FEATURES.ACCOUNT_HISTORY;
      break;
    case NAVIGATION.PersonalDocuments:
      claimLink = FEATURES.PERSONAL_DOCUMENTS;
      break;
    case NAVIGATION.PaymentAuthorisation:
      claimLink = FEATURES.PAYMENT_AUTHORISATION;
      break;
    case NAVIGATION.Utility:
      claimLink = FEATURES.UTILITY;
      break;
    case NAVIGATION.DocumentsApproval:
      claimLink = FEATURES.DOCUMENTS_APPROVAL;
      break;
    case NAVIGATION.ShowFindAContractor:
      claimLink = FEATURES.SHOW_FIND_A_CONTRACTOR;
      break;
    //case NAVIGATION.TrusteeDashboard:
    //  claimLink = FEATURES.TRUSTEE_DASHBOARD;
    //      break;
  }

  return claimLink;
};

export const routeToClaim = routeName => {
  let claim;
  switch (routeName) {
    case NAVIGATION.PropertyList:
      claim = {
        order: 1,
        description: 'View Accounts History'
      };
      break;
    case NAVIGATION.AccountHistory:
      claim = {
        order: 2,
        description: 'View Accounts History'
      };
      break;
    case NAVIGATION.BuildingDocuments:
      claim = {
        order: 3,
        description: 'View Building Documents'
      };
      break;
    case NAVIGATION.Compliance:
      claim = {
        order: 4,
        description: 'View Fire Compliance'
      };
      break;
    case NAVIGATION.FinancialPack:
      claim = {
        order: 5,
        description: 'View Financials'
      };
      break;
    case NAVIGATION.PaymentApprovals:
      claim = {
        order: 6,
        description: 'View Payments'
      };
      break;
    case NAVIGATION.PaymentAuthorisation:
      claim = {
        order: 7,
        description: 'View Payment Bands'
      };
      break;
    case NAVIGATION.PersonalDocuments:
      claim = {
        order: 8,
        description: 'View Personal Documents'
      };
      break;
    case NAVIGATION.ManageTents:
      claim = {
        order: 9,
        description: 'Register Tenant'
      };
      break;
    case NAVIGATION.MyProfile:
      claim = {
        order: 10,
        description: 'My Profile'
      };
      break;
    case NAVIGATION.Utility:
      claim = {
        order: 11,
        description: 'View Building Documents'
      };
      break;
    case NAVIGATION.DocumentsApproval:
       claim = {
         order: 12,
         description: 'View Documents Approval'
       };
       break;
    case NAVIGATION.ShowFindAContractor:
       claim = {
          order: 13,
          description: 'Show Find A Contractor'
       };
       break;

      //case NAVIGATION.TrusteeDashboard:
      // claim = {
      //   order: 13,
      //   description: 'Trustee Dashboard'
      // };
      // break;
  }

  return claim;
};

export const NAVIGATION_SORTED = originalNavigation => {
  const sortedNavigation = originalNavigation.sort(sorting);
  return sortedNavigation;
};
